export const mustTerm = term => ({
  context: "must",
  term
});

export const makeListType = type => terms => ({
  type,
  terms
});

export const makeAnyOfList = makeListType('AnyOfList');
export const makeAllOfList = makeListType('AllOfList');

export const yearAsRange = (min, max) => ({
  type: "Range",
  ranges: [
    {
      context: "must",
      min,
      max
    }
  ]
});


export const accord = {
  context: "must",
  modelId: 880,
  model: "Accord",
  make: "Honda",
  isEntireMakeSelected: false
};

export const civic = {
  context: "must",
  modelId: 880,
  model: "Civic",
  make: "Honda",
  isEntireMakeSelected: false
};

export const enclave = {
  context: "must",
  modelId: 880,
  model: "Enclave",
  make: "Buick",
  isEntireMakeSelected: false
};

export const encore = {
  context: "must",
  modelId: 880,
  model: "Encore",
  make: "Buick",
  isEntireMakeSelected: false
};

export const cruze = {
  context: "must",
  modelId: 880,
  model: "Cruze",
  make: "Chevrolet",
  isEntireMakeSelected: false
};

export const corolla = {
  context: "must",
  modelId: 880,
  model: "Corolla",
  make: "Toyota",
  isEntireMakeSelected: false
};

export const rangeRoverSport = {
  context: "must",
  modelId: 1109,
  model: "Range Rover Sport",
  make: "Land Rover",
  isEntireMakeSelected: false
};

export const coupe = mustTerm('Coupe');
export const sedan = mustTerm('Sedan');
export const truck = mustTerm('Truck');
export const pickup = mustTerm('Pickup');
export const suv = mustTerm('Suv');


export const bodyStylesCoupe = makeAnyOfList([coupe]);
export const bodyStylesSedan = makeAnyOfList([sedan]);
export const bodyStylesSuv = makeAnyOfList([suv]);
export const bodyStylesTruck = makeAnyOfList([truck]);
export const bodyStylesPickup = makeAnyOfList([pickup]);
export const bodyStylesCoupeSedanTruck = makeAnyOfList([sedan, coupe, truck]);
export const bodyStylesCoupeSedan = makeAnyOfList([sedan, coupe]);

export const a3 = {
  "context": "must",
  "modelId": 894,
  "model": "A3",
  "make": "Audi",
  "isEntireMakeSelected": false
};

export const a4 = {
  "context": "must",
  "modelId": 893,
  "model": "A4",
  "make": "Audi",
  "isEntireMakeSelected": false
};

export const a5 = {
  "context": "must",
  "modelId": 890,
  "model": "A5",
  "make": "Audi",
  "isEntireMakeSelected": false
};

export const s6 = {
  "context": "must",
  "modelId": 899,
  "model": "S6",
  "make": "Audi",
  "isEntireMakeSelected": false
};

export const stelvio = {
  "context": "must",
  "modelId": 999,
  "model": "Stelvio",
  "make": "Alfa Romeo",
  "isEntireMakeSelected": false
};

export const cClass = {
  "context": "must",
  "modelId": 1152,
  "model": "C-Class",
  "make": "Mercedes-Benz",
  "isEntireMakeSelected": false
};

export const tucson = {
  "context": "must",
  "modelId": 1057,
  "model": "Tucson",
  "make": "Hyundai",
  "isEntireMakeSelected": false
};

export const silverado1500CrewCab = {
  "context": "must",
  "modelId": 965,
  "model": "Silverado 1500 Crew Cab",
  "make": "Chevrolet",
  "isEntireMakeSelected": false
};



const makeModelList = models => ({
    type: "MakeModel",
    models
});


export const audiAllModels = [a3, a4, s6].map(x=>({...x, isEntireMakeSelected: true}));
export const mercedesAllModels = [cClass].map(x=>({...x, isEntireMakeSelected: true}));
export const alfaRomeoAllModels = [stelvio].map(x=>({...x, isEntireMakeSelected: true}));
export const chevroletAllModels = [cruze, silverado1500CrewCab].map(x=>({...x, isEntireMakeSelected: true}));

export const modelIdsOnlyCivic = makeModelList([civic]);
export const modelIdsOnlyAccord = makeModelList([accord]);
export const modelIdsOnlyCivicAccord = makeModelList([civic, accord]);
export const modelIdsAudiAllModels = makeModelList(audiAllModels);
export const modelIdsAudiA3 = makeModelList([a3]);
export const modelIdsAudiA4 = makeModelList([a4]);
export const modelIdsAudiA3A4A5 = makeModelList([a3, a4, a5]);
export const modelIdsMercedesBenzCClass = makeModelList([cClass]);
export const modelIdsHyundaiTucson = makeModelList([tucson]);
export const modelIdsLandRoverRangeRoverSport = makeModelList([rangeRoverSport]);
export const modelIdsChevroletSilverado1500CrewCab = makeModelList([silverado1500CrewCab]);

export const acuraAllModels = [
  {
    context: "must",
    modelId: 880,
    model: "ILX",
    make: "Acura",
    isEntireMakeSelected: true
  },
  {
    context: "must",
    modelId: 877,
    model: "MDX",
    make: "Acura",
    isEntireMakeSelected: true
  },
  {
    context: "must",
    modelId: 878,
    model: "RDX",
    make: "Acura",
    isEntireMakeSelected: true
  },
  {
    context: "must",
    modelId: 881,
    model: "RLX",
    make: "Acura",
    isEntireMakeSelected: true
  },
  {
    context: "must",
    modelId: 876,
    model: "TL",
    make: "Acura",
    isEntireMakeSelected: true
  },
  {
    context: "must",
    modelId: 882,
    model: "TLX",
    make: "Acura",
    isEntireMakeSelected: true
  },
  {
    context: "must",
    modelId: 874,
    model: "TSX",
    make: "Acura",
    isEntireMakeSelected: true
  }
];

export const blue = mustTerm('Blue');
export const red = mustTerm('Red');
export const green = mustTerm('Green');
export const black = mustTerm('Black');
export const orange = mustTerm('Orange');

export const colorsOnlyOrange = makeAnyOfList([orange]);
export const colorsOnlyBlack = makeAnyOfList([black]);
export const colorsOrangeBlack = makeAnyOfList([orange, black]);
export const colorsOrangeBlackBlue = makeAnyOfList([orange, black, blue]);
export const colorsGreenBlack = makeAnyOfList([green, black]);
export const colorsGreenBlue = makeAnyOfList([green, blue]);
export const colorsRedBlack = makeAnyOfList([red, black]);
export const colorsRedBlue = makeAnyOfList([red, blue]);
export const colorsBlueBlack = makeAnyOfList([blue, black]);



export const leatherInterior = mustTerm('Leather Interior');
export const handsFree = mustTerm('Hands Free');
export const satelliteRadio = mustTerm('Satellite Radio');
export const sunRoof = mustTerm('Sun Roof');
export const gpsNavigation = mustTerm('GPS Navigation');
export const heatedSeats = mustTerm('Heated Seats');

export const featuresHandsFreeSatelliteRadio = makeAllOfList([
    handsFree,
    satelliteRadio
  ]);

export const featuresLeatherInterior = makeAllOfList([leatherInterior]);
export const featuresGpsNavigation = makeAllOfList([gpsNavigation]);
export const featuresHandsFree = makeAllOfList([handsFree]);
export const featuresSunRoof = makeAllOfList([sunRoof]);
export const featuresHeatedSeats = makeAllOfList([heatedSeats]);
export const featuresGpsNavigationHandsFree = makeAllOfList([gpsNavigation, handsFree]);
export const featuresLeatherInteriorSatelliteRadio = makeAllOfList([leatherInterior, satelliteRadio]);
export const featuresLeatherInteriorSatelliteRadioHandsFree = makeAllOfList([leatherInterior, satelliteRadio, handsFree]);
export const featuresHeatedSeatsSunRoof = makeAllOfList([heatedSeats, sunRoof]);




export const fourCylinders = mustTerm('FourCylinders');
export const sixCylinders = mustTerm('SixCylinders');
export const eightCylinders = mustTerm('EightCylinders');
export const otherCylinders = mustTerm('OtherCylinders');

export const cylindersFour = makeAnyOfList([fourCylinders]);
export const cylindersFourEight = makeAnyOfList([fourCylinders, eightCylinders]);
export const cylindersFourSixEight = makeAnyOfList([fourCylinders, sixCylinders, eightCylinders]);
export const cylindersFourEightOther = makeAnyOfList([fourCylinders, eightCylinders, otherCylinders]);



export const gas = mustTerm('Gas');
export const electric = mustTerm('Electric');
export const hybrid = mustTerm('Hybrid');

export const fuelTypesGas = makeAnyOfList([gas]);
export const fuelTypesElectric = makeAnyOfList([electric]);
export const fuelTypesGasElectric = makeAnyOfList([gas, electric]);
export const fuelTypesGasElectricHybrid = makeAnyOfList([gas, electric, hybrid]);
export const fuelTypesElectricHybrid = makeAnyOfList([electric, hybrid]);


export const manual = mustTerm('Manual');
export const automatic = mustTerm('Automatic');

export const transmissionsManual = makeAnyOfList([ manual ]);
export const transmissionsManualAutomatic = makeAnyOfList([ manual, automatic ]);


export const trimLT = mustTerm('LT');
export const trimEXL = mustTerm('EX-L');
export const trimLX = mustTerm('LX');
export const trimUltraPremiumPlus = mustTerm('Ultra Premium Plus');

export const trimsOnlyLT = makeAnyOfList([trimLT]);
export const trimsOnlyEXL = makeAnyOfList([trimEXL]);
export const trimsOnlyEXLLX = makeAnyOfList([trimEXL, trimLX]);
export const trimsOnlyUltraPremiumPlus = makeAnyOfList([trimUltraPremiumPlus]);


export const fwd = mustTerm('Fwd');
export const rwd = mustTerm('Rwd');
export const awd = mustTerm('Awd');

export const driveTypesFwd = makeAnyOfList([fwd]);
export const driveTypesFwdRwdAwd = makeAnyOfList([fwd, rwd, awd]);

